module.exports = __webpack_public_path__ + "img/ctrl-cross-resonance-stub-mid--i.6fa12dbb.svg";